import { motion } from 'framer-motion';

const stats = [
  {
    icon: 'ri-heart-pulse-line',
    number: '3.2M',
    label: 'Cats Need Homes',
    description: 'Millions of cats enter shelters every year waiting for loving families.',
    color: 'bg-rose-50 text-rose-600',
    accentColor: 'text-rose-600',
  },
  {
    icon: 'ri-shield-check-line',
    number: '100%',
    label: 'Adoption Saves Lives',
    description: 'Every adoption opens space for another cat to be rescued and cared for.',
    color: 'bg-emerald-50 text-emerald-600',
    accentColor: 'text-emerald-600',
  },
  {
    icon: 'ri-heart-line',
    number: 'Perfect',
    label: 'Find Your Match',
    description: 'From playful kittens to calm seniors, there\'s a perfect cat for every home.',
    color: 'bg-amber-50 text-amber-600',
    accentColor: 'text-amber-600',
  },
];

export default function WhyAdopt() {
  return (
    <section className="py-12 sm:py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading font-bold text-2xl sm:text-4xl lg:text-5xl text-gray-900 mb-3 sm:mb-4"
          >
            Why <span className="text-accent">Adopt</span> a Cat?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="font-body text-gray-500 text-sm sm:text-base max-w-2xl mx-auto"
          >
            Adoption is a life-changing decision that brings joy to both you and your new feline friend.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 p-6 sm:p-8 text-center group"
            >
              <div className={`w-16 h-16 sm:w-20 sm:h-20 ${stat.color} rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-5 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${stat.icon} text-3xl sm:text-4xl`}></i>
              </div>
              <h3 className={`font-heading font-bold text-3xl sm:text-4xl ${stat.accentColor} mb-2`}>
                {stat.number}
              </h3>
              <h4 className="font-heading font-bold text-base sm:text-lg text-gray-900 mb-2 sm:mb-3">
                {stat.label}
              </h4>
              <p className="font-body text-xs sm:text-sm text-gray-600 leading-relaxed">
                {stat.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="text-center mt-10 sm:mt-12"
        >
          <a
            href="#adoptable-cats"
            className="inline-flex items-center gap-2 px-8 py-4 bg-accent hover:bg-accent/90 text-white font-heading font-bold text-sm sm:text-base rounded-full transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-search-line text-lg"></i>
            Browse Adoptable Cats
          </a>
        </motion.div>
      </div>
    </section>
  );
}